import MainInfo from "./MainInfo";
export default MainInfo;
